<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">
        <div class="input-card mx-lg-auto">
            <div class="input-card-form">
              <input type="text" v-model="response"  class="form-control text-center" placeholder="Ej: 00000000F" @change="ValidarRespuesta" @mouseleave="ValidarRespuesta" @keypress="ValidarRespuesta" @paste="ValidarRespuesta" />
            </div>
          </div>
        </div>
    </div>
</template>

<script>


import ValidateNIF from "./DniNieCif/ValidarNIF.js"

export default {
  name: 'Nif',
  props: {

    response: String,
    FormularioTag: String,
    idQuestion: Number,
    allresponses: Object

  },

  methods: {

      ValidarRespuesta : function(){

        if (this.response != null)
        {
           
            var datosNIF = ValidateNIF.ValidateSpanishID(this.response);

            var valido = datosNIF["valid"];

        } else {
            
            var valido = false;

        }

        if (valido == true)
        {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: true,
                response: this.response,
                allresponses: datosNIF
            };

            
            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        } else {

            let Mutation = {

                formulario: this.FormularioTag,
                question: this.idQuestion,
                validate: false,
                response: this.response,
                allresponses: datosNIF

            };

            this.$store.commit('actualizarRespuestaFormulario', Mutation);    

        }

      }


  }
}
</script>